"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _vuex = require("vuex");
var _booking = require("@/api/bookSpace/booking");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _cancelBookingListMsg = _interopRequireDefault(require("./cancelBookingListMsg"));
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "",
  components: {
    dragDialog: _DragDialog.default,
    Pagination: _Pagination.default,
    cancelBookingListMsg: _cancelBookingListMsg.default
  },
  props: {
    ids: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      form: {
        ids: '',
        reason: ''
      },
      rules: {
        reason: [{
          required: true,
          message: this.$t('home.placehold'),
          trigger: 'change'
        }]
      },
      cancelBookingListMsgVisible: false
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language', 'userInfo'])),
  created: function created() {},
  mounted: function mounted() {},
  methods: {
    opened: function opened() {
      this.form.ids = this.ids;
      this.form.reason = '';
    },
    handleClose: function handleClose() {
      this.$parent.cancelBookingIds = '';
      this.$parent.cancelBookingReasonVisible = false;
    },
    handelCancelBooking: function handelCancelBooking() {
      var _this = this;
      this.$refs.form.validate(function (valid) {
        if (valid) {
          _this.cancelBookingListMsg = '';
          _this.loading = _this.$loading({
            lock: true,
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          (0, _booking.cancelBookingHeadWebComs)(_this.form).then(function (res) {
            if (res.success) {
              if (res.data) {
                _this.cancelBookingListMsg = res.data;
                _this.cancelBookingListMsgVisible = true;
                _this.handleClose();
                _this.$parent.handleSearch();
                _this.loading.close();
              } else {
                _this.$message.success(_this.$t('home.cancelBookingMessage'));
                _this.handleClose();
                _this.$parent.handleSearch();
                _this.loading.close();
              }
            } else {
              _this.$message.error(res.errorMessages[0]);
              _this.handleClose();
              _this.$parent.handleSearch();
              _this.loading.close();
            }
          }).finally(function (_) {
            _this.loading.close();
          });
        }
      });
    }
  }
};